/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_Optional_MessageInputs */

const en_gift_optional_message = /** @type {(inputs: Gift_Optional_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add an optional gift message...`)
};

const es_gift_optional_message = /** @type {(inputs: Gift_Optional_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir un mensaje de regalo opcional...`)
};

const fr_gift_optional_message = /** @type {(inputs: Gift_Optional_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter un message cadeau (facultatif)...`)
};

const de_gift_optional_message = /** @type {(inputs: Gift_Optional_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge eine optionale Geschenknachricht hinzu...`)
};

const id_gift_optional_message = /** @type {(inputs: Gift_Optional_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambahkan pesan hadiah opsional...`)
};

/** @type {(inputs: Gift_Optional_MessageInputs) => LocalizedString} */
const ja_gift_optional_message = en_gift_optional_message;

/** @type {(inputs: Gift_Optional_MessageInputs) => LocalizedString} */
const zh_gift_optional_message = en_gift_optional_message;

/** @type {(inputs: Gift_Optional_MessageInputs) => LocalizedString} */
const ar_gift_optional_message = en_gift_optional_message;

/** @type {(inputs: Gift_Optional_MessageInputs) => LocalizedString} */
const it_gift_optional_message = en_gift_optional_message;

/** @type {(inputs: Gift_Optional_MessageInputs) => LocalizedString} */
const ru_gift_optional_message = en_gift_optional_message;

/** @type {(inputs: Gift_Optional_MessageInputs) => LocalizedString} */
const pt_gift_optional_message = en_gift_optional_message;

/** @type {(inputs: Gift_Optional_MessageInputs) => LocalizedString} */
const ko_gift_optional_message = en_gift_optional_message;

/**
* | output |
* | --- |
* | "Add an optional gift message..." |
*
* @param {Gift_Optional_MessageInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const gift_optional_message = /** @type {((inputs?: Gift_Optional_MessageInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_Optional_MessageInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gift_optional_message(inputs)
	if (locale === "es") return es_gift_optional_message(inputs)
	if (locale === "fr") return fr_gift_optional_message(inputs)
	if (locale === "de") return de_gift_optional_message(inputs)
	if (locale === "ja") return ja_gift_optional_message(inputs)
	if (locale === "zh") return zh_gift_optional_message(inputs)
	if (locale === "ar") return ar_gift_optional_message(inputs)
	if (locale === "id") return id_gift_optional_message(inputs)
	if (locale === "it") return it_gift_optional_message(inputs)
	if (locale === "ru") return ru_gift_optional_message(inputs)
	if (locale === "pt") return pt_gift_optional_message(inputs)
	return ko_gift_optional_message(inputs)
});